import { render, staticRenderFns } from "./WamFactorySettings.vue?vue&type=template&id=32ba8baa&lang=pug"
import script from "./WamFactorySettings.vue?vue&type=script&lang=js"
export * from "./WamFactorySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports